module.exports = __webpack_public_path__ + "files/bba534a3017500d0c804866b4b10961e.png";